import { render, staticRenderFns } from "./PrivacyLines.vue?vue&type=template&id=73d4d0ed&"
import script from "./PrivacyLines.vue?vue&type=script&lang=js&"
export * from "./PrivacyLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports